@if (naytaTyyppivalinta()) {
  <div class="all" mat-dialog-content>
    <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
    <h2 class="light-blue-text otsikko">{{ 'lasku.asiakas-dialog.uusi-otsikko' | translate | async }}</h2>
    @if (data.esitaytettyNimi) {
      <div class="tyyppivalinta-nimi">{{ data.esitaytettyNimi }}</div>
    }
    <div class="tyyppivalinta-kysymys">{{ 'lasku.asiakas-dialog.tyyppi-kysymys' | translate | async }}</div>
    <div class="tyyppivalinnat">
      <button #yritysVaihtoehto type="button" class="tyyppivaihtoehto" cdkFocusInitial (click)="valitseAsiakastyyppi(asiakastyypit.YRITYS)" (keydown.arrowdown)="$event.preventDefault(); henkiloVaihtoehto.focus()" (keydown.arrowup)="$event.preventDefault(); henkiloVaihtoehto.focus()">
        <span class="tyyppi-ikoni"><mat-icon>business</mat-icon></span>
        <span class="tyyppi-tekstit">
          <span class="tyyppi-nimi">{{ 'lasku.asiakas-dialog.tyyppi-yritys' | translate | async }}</span>
          <span class="tyyppi-kuvaus">{{ 'lasku.asiakas-dialog.tyyppi-yritys-kuvaus' | translate | async }}</span>
        </span>
        <mat-icon class="tyyppi-nuoli">chevron_right</mat-icon>
      </button>
      <button #henkiloVaihtoehto type="button" class="tyyppivaihtoehto" (click)="valitseAsiakastyyppi(asiakastyypit.HENKILO)" (keydown.arrowdown)="$event.preventDefault(); yritysVaihtoehto.focus()" (keydown.arrowup)="$event.preventDefault(); yritysVaihtoehto.focus()">
        <span class="tyyppi-ikoni"><mat-icon>person</mat-icon></span>
        <span class="tyyppi-tekstit">
          <span class="tyyppi-nimi">{{ 'lasku.asiakas-dialog.tyyppi-henkilo' | translate | async }}</span>
          <span class="tyyppi-kuvaus">{{ 'lasku.asiakas-dialog.tyyppi-henkilo-kuvaus' | translate | async }}</span>
        </span>
        <mat-icon class="tyyppi-nuoli">chevron_right</mat-icon>
      </button>
    </div>
    <div class="napit">
      <button class="secondarybutton" mat-button (click)="pyydaSulkemista()" type="button">{{ 'yleiset.peruuta' | translate | async }}</button>
    </div>
  </div>
}
<div class="all" mat-dialog-content [hidden]="naytaTyyppivalinta()">
  <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
  <h2 class="light-blue-text otsikko">
    <mat-icon>{{ asiakastyyppi() === asiakastyypit.HENKILO ? 'person' : 'business' }}</mat-icon>
    {{ otsikonAvain | translate | async }}
  </h2>
  @if (data.asiakas) {
    <div class="huomautus-oranssi">{{ 'lasku.asiakas-dialog.rekisteri-huomautus' | translate | async }}</div>
  }

  <form novalidate>
    <section class="osio">
      <div class="osion-otsikko">{{ 'lasku.asiakas-dialog.yhteystiedot' | translate | async }}</div>
      <div class="kentat">
        @if (onkoUusiYritysasiakas) {
          <app-ytj-haku class="leveä" [esitaytettyHakusana]="data.esitaytettyNimi" [valittuYtunnus]="lomake.ytunnus().value()" (yritysValittu)="kaytaValittuaYtjYritysta($event)" (osoiteSaatu)="kaytaYtjOsoitetta($event)"></app-ytj-haku>
        }

        <mat-form-field>
          <mat-label>{{ nimenOtsikonAvain | translate | async }}</mat-label>
          <input #nimiKentta type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.nimi" [placeholder]="nimenPaikkamerkinAvain | translate | async" matInput data-lpignore="true" />
          @if (onkoVirhe(lomake.nimi, 'required')) {
            <mat-error>{{ 'lasku.validation.nimi.required' | translate | async }}</mat-error>
          }
          @if (onkoVirhe(lomake.nimi, 'minLength')) {
            <mat-error>{{ 'lasku.validation.nimi.minlength' | translate | async }}</mat-error>
          }
        </mat-form-field>

        @if (asiakastyyppi() === asiakastyypit.HENKILO) {
          <mat-form-field subscriptSizing="dynamic" (click)="naytaMaanLukitusohjeHetkeksi()">
            <mat-label>{{ 'lasku.maa' | translate | async }}</mat-label>
            <mat-select [formField]="lomake.maa">
              @for (maa of suodatetutMaat | async; track maa.koodi) {
                <mat-option [value]="maa.koodi">{{ maa.nimi }}</mat-option>
              }
            </mat-select>
            @if (lomake.maa().disabled() && naytaMaanLukitusohje()) {
              <mat-hint class="maan-lukitusohje">{{ 'lasku.asiakas-dialog.maa-kotimaan-myynnissa' | translate | async }}</mat-hint>
            }
            @if (onkoVirhe(lomake.maa, 'required')) {
              <mat-error>{{ 'lasku.validation.maa.required' | translate | async }}</mat-error>
            }
          </mat-form-field>
        } @else {
          <mat-form-field>
            <mat-label>{{ ytunnusPlaceholderObservable | async }}</mat-label>
            <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.ytunnus" placeholder="1234567-8" matInput data-lpignore="true" />
            <mat-hint>{{ vatTunnuksenValidointitulos | async }}</mat-hint>
            @if (onkoVirhe(lomake.ytunnus, 'required')) {
              <mat-error>{{ 'lasku.validation.ytunnus.required' | translate | async }}</mat-error>
            }
            @if (onkoVirhe(lomake.ytunnus, 'invalid_ytunnus')) {
              <mat-error>{{ 'lasku.validation.ytunnus.invalid-ytunnus' | translate | async }}</mat-error>
            }
            @if (onkoVirhe(lomake.ytunnus, 'invalid_vat_number')) {
              <mat-error>{{ 'lasku.validation.ytunnus.invalid-vat-number' | translate | async }}</mat-error>
            }
            @if (onkoVirhe(lomake.ytunnus, 'invalid_vat_number_or_ytunnus')) {
              <mat-error>{{ 'lasku.validation.ytunnus.invalid-vat-number-or-ytunnus' | translate | async }}</mat-error>
            }
          </mat-form-field>
        }

        <mat-form-field class="leveä">
          <mat-label>{{ 'lasku.katuosoite' | translate | async }}</mat-label>
          <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.katuosoite" matInput data-lpignore="true" />
          @if (onkoVirhe(lomake.katuosoite, 'required')) {
            <mat-error>{{ 'lasku.validation.katuosoite.required' | translate | async }}</mat-error>
          }
        </mat-form-field>

        <div class="postiosoite">
          <mat-form-field>
            <mat-label>{{ 'lasku.postinro' | translate | async }}</mat-label>
            <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.postinro" matInput data-lpignore="true" />
            @if (onkoVirhe(lomake.postinro, 'required')) {
              <mat-error>{{ 'lasku.validation.postinro.required' | translate | async }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'lasku.postitoimipaikka' | translate | async }}</mat-label>
            <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.postitoimipaikka" matInput data-lpignore="true" />
            @if (onkoVirhe(lomake.postitoimipaikka, 'required')) {
              <mat-error>{{ 'lasku.validation.postitoimipaikka.required' | translate | async }}</mat-error>
            }
          </mat-form-field>
        </div>

        @if (asiakastyyppi() !== asiakastyypit.HENKILO) {
          <mat-form-field subscriptSizing="dynamic" (click)="naytaMaanLukitusohjeHetkeksi()">
            <mat-label>{{ 'lasku.maa' | translate | async }}</mat-label>
            <mat-select [formField]="lomake.maa">
              @for (maa of suodatetutMaat | async; track maa.koodi) {
                <mat-option [value]="maa.koodi">{{ maa.nimi }}</mat-option>
              }
            </mat-select>
            @if (lomake.maa().disabled() && naytaMaanLukitusohje()) {
              <mat-hint class="maan-lukitusohje">{{ 'lasku.asiakas-dialog.maa-kotimaan-myynnissa' | translate | async }}</mat-hint>
            }
            @if (onkoVirhe(lomake.maa, 'required')) {
              <mat-error>{{ 'lasku.validation.maa.required' | translate | async }}</mat-error>
            }
          </mat-form-field>
        }

        @if (ehdotettuYtjOsoite()) {
          <div class="leveä ytj-osoite-ehdotus">
            <mat-icon>business</mat-icon>
            <div class="ytj-osoite-tiedot">
              <div class="ytj-osoite-otsikko">{{ 'lasku.asiakas-dialog.ytj-osoite' | translate | async }}</div>
              <div>{{ ehdotettuYtjOsoite().katuosoite }}</div>
              <div>{{ ehdotettuYtjOsoite().postinro }} {{ ehdotettuYtjOsoite().postitmp }}</div>
            </div>
            <button type="button" class="ytj-osoite-nappi" (click)="kaytaEhdotettuaYtjOsoitetta()">{{ 'lasku.asiakas-dialog.kayta-tata-osoitetta' | translate | async }}</button>
          </div>
        }
      </div>
    </section>

    <section class="osio">
      <div class="osion-otsikko">{{ 'lasku.asiakas-dialog.laskutuksen-oletukset' | translate | async }}</div>
      <div class="kentat">
        @if ((laskutusprofiilitObservable | async)?.length > 1) {
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ 'lasku.asiakas-dialog.laskutusprofiili' | translate | async }}</mat-label>
            <mat-select [formField]="lomake.laskutusprofiiliAvain" [canSelectNullableOptions]="true">
              @for (laskutusprofiili of laskutusprofiilitObservable | async; track laskutusprofiili.avain) {
                <mat-option [value]="laskutusprofiili.avain">{{ laskutusprofiili.nimi }}</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'lasku.asiakas-dialog.laskutusprofiili-vihje' | translate | async }}</mat-hint>
          </mat-form-field>
        }
        <mat-form-field>
          <mat-label>{{ 'lasku.myyntilaji' | translate | async }}</mat-label>
          <mat-select [compareWith]="vertaaTyyppia" [formField]="lomake.tyyppi">
            @for (tyyppi of tyypitObservable | async; track tyyppi.avain) {
              <mat-option [value]="tyyppi">{{ 'myynnin-laji.' + tyyppi.avain | translate | async }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (lomake.tyyppi().value()?.avain === 'kuleur') {
          <app-eu-kuluttajamyynti-huomautus class="leveä eu-kuluttajamyynti-huomautus"></app-eu-kuluttajamyynti-huomautus>
        }

        <mat-form-field>
          <mat-label>{{ 'lasku.valuutta' | translate | async }}</mat-label>
          <mat-select [formField]="lomake.valuutta">
            @for (valuutta of valuutatObservable | async; track valuutta.koodi) {
              <mat-option [value]="valuutta.koodi">{{ valuutta.koodi }} ({{ 'valuutta.' + valuutta.koodi | translate | async }})</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (lomake.maksuaikaValinta().value() === 'muu') {
          <mat-form-field>
            <mat-label>{{ 'lasku.maksuehto' | translate | async }}</mat-label>
            <input type="number" step="1" [formField]="lomake.maksuaikaa" matInput />
            <span matSuffix>{{ 'lasku.pv-netto' | translate | async }}</span>
            @if (asiakastyyppi() === asiakastyypit.HENKILO) {
              <mat-hint>{{ 'lasku.asiakas-dialog.kuluttajan-maksuaika' | translate | async }}</mat-hint>
            }
          </mat-form-field>
        } @else {
          <mat-form-field>
            <mat-label>{{ 'lasku.maksuehto' | translate | async }}</mat-label>
            <mat-select [formField]="lomake.maksuaikaValinta">
              @for (paivia of maksuaikaVaihtoehdot; track paivia) {
                <mat-option [value]="paivia">{{ paivia }} {{ 'lasku.pv-netto' | translate | async }}</mat-option>
              }
              <mat-option value="muu">{{ 'lasku.muu' | translate | async }}</mat-option>
            </mat-select>
            @if (asiakastyyppi() === asiakastyypit.HENKILO) {
              <mat-hint>{{ 'lasku.asiakas-dialog.kuluttajan-maksuaika' | translate | async }}</mat-hint>
            }
          </mat-form-field>
        }

        <mat-form-field>
          <mat-label>{{ 'lasku.kieli' | translate | async }}</mat-label>
          <mat-select [formField]="lomake.kieli">
            @for (kieli of kielet | async; track kieli) {
              <mat-option [value]="kieli">{{ 'kieli.' + kieli | translate | async }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <section class="osio">
      <div class="osion-otsikko">{{ 'lasku.asiakas-dialog.laskun-toimitus' | translate | async }}</div>
      <div class="toimitus">
        <div class="toimitustavat" role="tablist">
          @if (asiakastyyppi() !== asiakastyypit.HENKILO) {
            <button type="button" role="tab" [class.valittu]="lomake.oletusLahetystapa().value() === LaskunLahetystapa.SAHKOINEN" (click)="valitseLahetystapa(LaskunLahetystapa.SAHKOINEN)">
              <mat-icon>bolt</mat-icon>
              {{ 'lasku.asiakas-dialog.toimitustapa.verkkolasku' | translate | async }}
            </button>
          }
          <button type="button" role="tab" [class.valittu]="lomake.oletusLahetystapa().value() === LaskunLahetystapa.SAHKOPOSTI" (click)="valitseLahetystapa(LaskunLahetystapa.SAHKOPOSTI)">
            <mat-icon>alternate_email</mat-icon>
            {{ 'lasku.asiakas-dialog.toimitustapa.sahkoposti' | translate | async }}
          </button>
          <button type="button" role="tab" [class.valittu]="lomake.oletusLahetystapa().value() === LaskunLahetystapa.ITSE" (click)="valitseLahetystapa(LaskunLahetystapa.ITSE)">
            <mat-icon>person</mat-icon>
            {{ 'lasku.asiakas-dialog.toimitustapa.itse' | translate | async }}
          </button>
        </div>

        @switch (lomake.oletusLahetystapa().value()) {
          @case (LaskunLahetystapa.SAHKOINEN) {
            <div class="kentat">
              <mat-form-field>
                <mat-label>{{ 'asiakas.verkkolaskuosoite' | translate | async }}</mat-label>
                <input type="text" [formField]="lomake.verkkolaskuosoite" placeholder="0037XXXXXXXX" matInput data-lpignore="true" />
                @if (onkoVirhe(lomake.verkkolaskuosoite, 'required')) {
                  <mat-error>{{ 'lasku.validation.verkkolaskuosoite.required' | translate | async }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'asiakas.verkkolaskuvalittaja' | translate | async }}</mat-label>
                <input type="text" [matAutocomplete]="operaattoriauto" [formField]="lomake.verkkolaskuvalittaja" [placeholder]="'lasku.asiakas-dialog.valitse-valittaja' | translate | async" matInput data-lpignore="true" />
                @if (onkoVirhe(lomake.verkkolaskuvalittaja, 'required')) {
                  <mat-error>{{ 'lasku.validation.verkkolaskuvalittaja.required' | translate | async }}</mat-error>
                }
              </mat-form-field>
              <mat-autocomplete #operaattoriauto="matAutocomplete" [displayWith]="valittajaDisplayFn">
                @for (operaattori of verkkolaskuoperaattorit | async; track operaattori.tunnus) {
                  <mat-option [value]="operaattori">{{ operaattori.tunnus }} {{ operaattori.nimi }}</mat-option>
                }
              </mat-autocomplete>
            </div>
            @if (haetaanVerkkolaskuosoitetta()) {
              <div class="haku-kaynnissa">
                <span class="pyorija"></span>
                <span>
                  <b>{{ 'lasku.asiakas-dialog.haetaan-verkkolaskuosoitetta' | translate | async }}</b>
                  <span class="haku-kaynnissa-alateksti">{{ 'lasku.asiakas-dialog.verkkolaskuosoite-taytetaan-automaattisesti' | translate | async }}</span>
                </span>
              </div>
            } @else if (verkkolaskuosoitteenHakuEpaonnistui()) {
              <div class="haku-epaonnistui error-text">
                {{ 'lasku.asiakas-dialog.verkkolaskuosoitteen-haku-epaonnistui' | translate | async }}
                <button type="button" class="yrita-uudelleen" (click)="haeVerkkolaskuosoiteUudelleen()">{{ 'lasku.asiakas-dialog.yrita-uudelleen' | translate | async }}</button>
              </div>
            } @else if (onkoVerkkolaskuosoiteHaettu) {
              <div class="haku-valmis">
                <mat-icon>check</mat-icon>
                {{ 'lasku.asiakas-dialog.verkkolaskuosoite-haettu' | translate | async }}
              </div>
            } @else if (asiakastyyppi() === asiakastyypit.YRITYS && !lomake.verkkolaskuosoite().value()?.trim()) {
              <div class="toimitus-vihje">{{ 'lasku.asiakas-dialog.verkkolaskuosoite-haetaan-kun-ytunnus' | translate | async }}</div>
            }
            @if (loydetytVerkkolaskuosoitteet().length > 1) {
              <div class="loydetyt-osoitteet">
                <div class="toimitus-vihje">{{ 'lasku.asiakas-dialog.useita-verkkolaskuosoitteita' | translate | async }}</div>
                @for (osoite of loydetytVerkkolaskuosoitteet(); track osoite.sahkoinenOsoite) {
                  <button type="button" class="loydetty-osoite" [class.valittu]="lomake.verkkolaskuosoite().value() === osoite.sahkoinenOsoite" (click)="valitseVerkkolaskuosoite(osoite)">
                    <span class="loydetyn-nimi">{{ osoite.nimi }}</span>
                    <span class="loydetyn-osoite">{{ osoite.sahkoinenOsoite }}</span>
                  </button>
                }
              </div>
            }
          }
          @case (LaskunLahetystapa.SAHKOPOSTI) {
            <div>
              <mat-chip-grid #vastaanottajaChips>
                @for (vastaanottaja of laskunVastaanottajat(); track vastaanottaja) {
                  <mat-chip-option [removable]="true" (removed)="poistaVastaanottaja(vastaanottaja)">
                    {{ vastaanottaja }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-option>
                }
              </mat-chip-grid>
              <mat-form-field>
                <mat-label>{{ 'lasku.asiakas-dialog.laskut-sahkopostiin' | translate | async }}</mat-label>
                <input type="email" autocomplete="kirjanpitotietoarkki" [matChipInputFor]="vastaanottajaChips" (blur)="lisaaVastaanottaja()" (matChipInputTokenEnd)="lisaaVastaanottaja()" [formField]="lomake.lisaavastaanottaja" [placeholder]="'lasku.asiakas-dialog.sahkoposti-paikkamerkki' | translate | async" matInput data-lpignore="true" />
                @if (onkoVirhe(lomake.lisaavastaanottaja, 'email', false)) {
                  <mat-error>{{ 'asiakas.validation.lisaavastaanottaja.email' | translate | async }}</mat-error>
                }
              </mat-form-field>
            </div>
          }
          @case (LaskunLahetystapa.ITSE) {
            <div class="toimitus-vihje">{{ 'lasku.asiakas-dialog.laheta-itse-info' | translate | async }}</div>
          }
        }
      </div>
    </section>
  </form>

  <div class="napit">
    @if (!data.asiakas) {
      <button class="vaihda-tyyppi" mat-button (click)="vaihdaAsiakastyyppia()" type="button">
        <mat-icon>chevron_left</mat-icon>
        {{ 'lasku.asiakas-dialog.vaihda-tyyppi' | translate | async }}
      </button>
      <span class="kasvata"></span>
    }
    @if (data.naytaPoista && data.asiakas) {
      <button class="poista-nappi" mat-button (click)="poistaAsiakas()" type="button">
        <mat-icon>delete</mat-icon>
        {{ 'lasku.asiakas-dialog.poista' | translate | async }}
      </button>
      <span class="kasvata"></span>
    }
    <button class="secondarybutton" mat-button (click)="pyydaSulkemista()" type="button">{{ 'yleiset.peruuta' | translate | async }}</button>
    <button class="primarybutton" mat-button (click)="tallenna()" type="button">{{ 'lasku.asiakas-dialog.tallenna' | translate | async }}</button>
  </div>
</div>
